import React, { useState, useCallback } from 'react'
import { usePlafondsRemise, useSocietes, useGroupSettings, useLibellesRemise } from './hooks'
import {
    ActivationCard,
    UnsavedChangesAlert,
    LibelleRemiseCollapse,
    SeuilRemiseGlobal
} from './components'

const PlafondsRemise: React.FC = () => {
    const [submitting, setSubmitting] = useState<boolean>(false)

    const {
        plafondsRemise,
        hasChanges: plafondsHasChanges,
        updatePlafond,
        savePlafondsRemise
    } = usePlafondsRemise()

    const { societes } = useSocietes()

    const {
        settings,
        hasChanges: groupSettingsHasChanges,
        updateSetting,
        saveSettings: saveGroupSettings
    } = useGroupSettings()

    const { libellesRemise } = useLibellesRemise()

    const hasChanges = plafondsHasChanges || groupSettingsHasChanges

    const handleSubmit = useCallback(async () => {
        setSubmitting(true)

        try {
            if (groupSettingsHasChanges) {
                await saveGroupSettings()
            }
            if (plafondsHasChanges) {
                await savePlafondsRemise()
            }
        } catch (error) {
            alert("Erreur lors de l'enregistrement")
            console.log(error)
        } finally {
            setSubmitting(false)
        }
    }, [groupSettingsHasChanges, plafondsHasChanges, saveGroupSettings, savePlafondsRemise])

    return (
        <div className='container-fluid mb-2'>
            <div className='row'>
                <div className='col'>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h2>Plafonds de remise</h2>
                        <UnsavedChangesAlert
                            show={hasChanges}
                            submitting={submitting}
                            onSubmit={handleSubmit}
                        />
                    </div>

                    <div className="d-inline-flex flex-column w-auto">
                        <ActivationCard
                            checked={settings?.discount_limit_enabled}
                            onChange={(value) => updateSetting('discount_limit_enabled', value)}
                        />

                        {settings?.discount_limit_enabled && (
                            <>
                                <SeuilRemiseGlobal
                                    value={settings?.max_global_discount}
                                    onChange={(value) => updateSetting('max_global_discount', value)}
                                />

                                {libellesRemise.map((libelle, index) => (
                                    <LibelleRemiseCollapse
                                        key={libelle.IDLibelleRemise}
                                        libelle={libelle}
                                        plafondsRemise={plafondsRemise}
                                        societes={societes}
                                        onPlafondChange={updatePlafond}
                                        defaultOpen={index === 0}
                                    />
                                ))}
                            </>
                        )}
                    </div>

                    <div className="row mt-4">
                        <div className="col text-center">
                            <button
                                disabled={!hasChanges}
                                type="submit"
                                className="btn btn-primary"
                                onClick={handleSubmit}
                            >
                                {submitting && <i className='fa fa-spinner fa-spin fa-fw mr-1'></i>}
                                Valider
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PlafondsRemise
